import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { translate } from "@classdojo/web/utils/translate";
import { useEffect } from "react";
import ScoreSection from "./ScoreSection";
import SurveyHeader from "./SurveyHeader";
import SurveyQuestion from "./SurveyQuestion";
import FullBleedScroller from "components/BeyondToolkit/FullBleedScroller";
import FullWidthButton from "components/FullWidthButton";
import { IdeasCloseIcon } from "components/IdeasIcons";
import RoundedIconButton from "components/RoundedIconButton";
import { logNpsSurveyEvent } from "src/utils/logEvent";

type ScorePageProps = {
  score: number | null;
  selectScore: (score: number) => void;
  submitScore: VoidFunction;
  closeSurvey: VoidFunction;
  innerHeight: string | number;
};

export default function ScorePage({ score, selectScore, submitScore, closeSurvey, innerHeight }: ScorePageProps) {
  // bulk ignore existing useEffects
  // eslint-disable-next-line @web-monorepo/no-useEffect
  useEffect(() => {
    //
    logNpsSurveyEvent({ eventName: "score_page.viewed" });
  }, []);

  const innerHeightNumber = Number(innerHeight);
  return (
    <FullBleedScroller
      background="dt_background_primary"
      fixedContent={
        <div sx={{ position: "absolute", top: 12, left: 12 }}>
          <RoundedIconButton
            backgroundColor="dt_background_primary"
            onClick={closeSurvey}
            data-name="score_page:close_button"
          >
            <IdeasCloseIcon color="dt_content_tertiary" />
          </RoundedIconButton>
        </div>
      }
    >
      <SurveyHeader innerHeight={innerHeightNumber} />
      <div sx={{ display: "flex", flexDirection: "column", position: "relative" }}>
        <SurveyQuestion question={translate("dojo.beyond:nps_survey.score_question")} innerHeight={innerHeightNumber} />
        <ScoreSection score={score} selectScore={selectScore} innerHeight={innerHeightNumber} />
        <div
          sx={{
            marginTop: RAW_cssValue(10),
            fontWeight: "bold",
            fontSize: 12,
            color: "dt_content_tertiary",
            textAlign: "center",
          }}
        >
          {translate("dojo.beyond:nps_survey.score_description")}
        </div>
      </div>
      <div sx={{ position: "relative", width: "100%", padding: RAW_cssValue(10) }}>
        <FullWidthButton
          data-name="score_page:submit"
          text={translate("dojo.beyond:nps_survey.submit")}
          disabled={score === null}
          onClick={submitScore}
          maxWidth={500}
        />
      </div>
    </FullBleedScroller>
  );
}
